import Api from "../../config/ApiConfig";
import { IOverrideRequestPostPayload, IPatchOverRequestPayload, IOverrideRequestSearchParam } from "./types";

const apiUrls = {
    overridesRequest: "api/v1/override_requests",
    searchOverrideRequests: "api/v1/searches/override_requests"
};

export const postOverrideRequest = (payload: IOverrideRequestPostPayload[]) =>
    Api.post(apiUrls.overridesRequest, payload)
        .then((response) => { return response })
        .catch((error) => { return error.response });

export const patchOverrideRequest = (param: string, payload: IPatchOverRequestPayload) =>
    Api.patch(apiUrls.overridesRequest + `/${param}`, payload)
        .then((response) => { return response })
        .catch((error) => { return error.response });

export const getOverrideRequestDetails = (param: string) =>
    Api.get(apiUrls.overridesRequest + `/${param}`)
        .then((response) => { return response })
        .catch((error) => { return error.response });

export const getParam = (param: string[] | undefined, paramType: string) => {
  let str: string = '';
  if (param && param?.length > 0) {
    str = `&${paramType}=${param}`;
  }
  return str;
}

export const getOverrideRequests = (params : IOverrideRequestSearchParam) =>
    Api.get(`${apiUrls.searchOverrideRequests}?skip=${params.skip}&top=${params.top}&count=${params.count}&orderby=${params.orderby}&queryType=full&search=${params.search}` +
        getParam(params.tableId, "tableId") + getParam(params.grantee, "grantee") + getParam(params.sourceId, "sourceId")
        + getParam(params.treatmentLevel, "treatmentLevel") + getParam(params.dataSteward, "dataSteward") 
        + getParam(params.status, "status"))
        .then((response) => { return response })
        .catch((error) => { return error.response });   